export let container= (_length)=>{
    return `
<div class="recommend-inner">
    <h2 class="recommend-title">추천 영상</h2>
    <ul class="recommend-list"></ul>
    <div class="paging paging-simple">
        <span class="paging-count"><em class="is-active">1</em> / ${_length}</span>
    </div>
    <a href="" class="recommend-close">${require('../../../svg/close.svg')}</a>
</div>`;
};